import { ColorShades } from "types/ColorsTypes";

export const appColors: Record<string, string | ColorShades> = {
  //** Figma */
  Black: "#1C2226",
  BlueDark: "#2b385f",
  FinecoBlueDark: "#2b385f",
  BlueLight: "#3794E6",
  BlueLink: "#2C70D4",
  CardCardGreen: "#228459",
  CardCardTurquoise: "#34A1B2",
  FinecoBlack: "#1C2226",
  FinecoBluePrimary: "#0133cd",
  FinecoGrayLight1: "#DDE0E6",
  FinecoGrayLight3: "#f5f7f9",
  FinecoWhite: "#FFFFFF",
  Gray3: "#C4C7CC",
  GrayLight2: "#EDEFF2",
  GrayLight3: "#f5f7f9",
  Gray1: "#70767D",
  gray2: "#8F949C",
  Green: "#008A00",
  orange: "#EB7100",
  yellow: "#FDC82F",
  red: "#BB2525",

  portfolio1: "#2b385f",
  portfolio2: "#34A1B2",

  productCard1: "#2C70D4",
  productCard2: "#228459",

  paletteChart1: "#2b385f",
  paletteChart2: "#228459",
  paletteChart3: "#5CA8E6",
  paletteChart4: "#009688",
  paletteChart5: "#2C70D4",
  paletteChart6: "#34A1B2",

  sostenibilitaPortfolio1Alta: "#2b385f",
  sostenibilitaPortfolio1Media: "#3794E6",
  sostenibilitaPortfolio1Bassa: "#5CA8E6",

  sostenibilitaPortfolio2Alta: "#34A1B2",
  sostenibilitaPortfolio2Media: "#62BFCD",
  sostenibilitaPortfolio2Bassa: "#B2DEE4",

  productCardBarChartLabel1: "rgba(16, 57, 118, 0.20)",
  productCardBarChartLabel2: "rgba(16, 57, 118, 0.20)",

  paletteBarChart1: "#2b385f",
  paletteBarChart2: "#228459",
  paletteBarChart3: "#5CA8E6",
  paletteBarChart4: "#009688",
  paletteBarChart5: "#2C70D4",
  paletteBarChart6: "#34A1B2",
  paletteBarChart7: "#5CA8E6",
  paletteBarChart8: "#006064",
  paletteBarChart9: "#459BE6",
  paletteBarChart10: "#27A69A",
  paletteBarChart11: "#64B5F6",
  paletteBarChart12: "#81DED9",
  paletteBarChart13: "#90CAF9",
  paletteBarChart14: "#AEECEF",
  paletteBarChart15: "#BBDEFB",

  white: "#ffffff",
  grayLight: "#f5f7f9",
  
  grey0: "#082D54",
  logoMain: "#5490f0",
  logoGradient: "#48a0c3",
  main: "#0133cd",

  finecoGray: "#70767D",
  finecoGrayLight: "#DDE0E6",

  tableHeaderBackground: "#2d6984",
  tableHeaderCopy: "#ffffff",
  tableHoverBackground: "#ffffff",
  tableHoverTextColor: "#1C2226",

  //** menu */
  menuBackgroundActive: "#0133cd",
  menuBackgroundHover: "#0133cd",
  menuIconActive: "#FDC82F",
  menuIconHover: "#FDC82F",
  menuIcon: "#1C2226",
  menuCopy: "#1C2226",
  menuActive: "#FFFFFF",
  menuHover: "#FFFFFF",

  //** review */
  finecoBluePrimary: "#0133cd",
  finecoBlueLight: "#dee2ec", 
  secondBackground: "#0133cd",
  gray4: "#e1e2e4",
  finecoBlack: "#1C2226",
  artifactsLabelTextColor: "#202124",
  artifactsDatoTextColor: "#34363a",
  portfolioChatBackground: "#202124",
  portfolioTitle: "#171717",
  portfolioPercPositive: "#007a29",
  portfolioPercNegative: "#ff0000",
  greenPill: "#007a29",
  toGradient: "#FDC82F",
  chatCopyColor: "#202124",
  chatInputBackground: "#171717",
  chatInputColor: "#2d6984",
  iconsColor: "#81C4FF",
  iconsColorLight: "#004684",
  iconActiveBackground: "#102440",

  tooltipBackground: "#34363a",
  tooltipText: "#ffffff",

  //** end review */
  primary: "#61FF9B",
  secondary: "#50FAFA",
  neutral: "#A1A1A1",

  //** toast */
  toastBackground: "#171717",
  toastDestructiveBackground: "#171717",

  indicator: { green: "#00fd8680", yellow: "#ffeb00c2", red: "#b91c1cd9" },
  olive: {
    50: "#F6F6D0",
    100: "#F3F3BF",
    200: "#ECEC9D",
    300: "#E6E67B",
    400: "#DFDF58",
    500: "#D9D936",
    600: "#B5B522",
    700: "#868619",
    800: "#565610",
    900: "#272707",
    950: "#101003",
  },
  gray: {
    100: "#f5f5f6",
    200: "#e0e1e3",
    300: "#c4c4c4",
    400: "#b5b8bf",
    500: "#9b9Fa7",
    600: "#4e5157",
    700: "#34363a",
    800: "#2a2b2e",
    900: "#202124",
  },
  magenta: {
    30: "#ff6692",
    100: "#73293B",
    200: "#662535",
    300: "#5A202E",
    400: "#4D1C28",
    500: "#401721",
    600: "#33121A",
    700: "#260E14",
    800: "#1A090D",
    900: "#0D0507",
  },
};
